import { useCallback, useEffect, useState } from 'react';

import useGame from './useGame';
import useGameSaveSocket from './useGameSaveSocket';

const useLobby = (gameId?: string) => {
  const [lobbyHasBeenShown, setLobbyHasBeenShown] = useState(false);
  const { autoSave } = useGameSaveSocket();
  const { game } = useGame(gameId);
  const showLobby = game?.isShowingLobby === true;
  useEffect(() => {
    if (showLobby || game?.isPlaying) {
      setLobbyHasBeenShown(true);
    }
  }, [showLobby, game?.isPlaying]);
  const setShowLobby = useCallback(
    (show?: boolean) => {
      const showLobbyToSave = show !== undefined ? show : !showLobby;
      if (game) {
        autoSave({
          game: { ...game, isShowingLobby: showLobbyToSave },
        });
      }
    },
    [showLobby, game, autoSave],
  );
  return { showLobby: showLobby, setShowLobby, lobbyHasBeenShown };
};

export default useLobby;
